import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataView } from "primereact/dataview";
import { formatDate } from "../../../constants/DateUtil/DateUtil";
import { Accordion, AccordionTab } from "primereact/accordion";
import SuccessModal from "../../SuccessModal";
import PickupRequest from "../../PickupAndDeliveryModal/PickupRequest";
import DeliveryRequest from "../../PickupAndDeliveryModal/DeliveryRequest";

const AdminJobRequests = ({ orderInfoData, JobType, callRequestApi }) => {
  const [selectedItem, setSelectedItem] = useState(orderInfoData[0]?.id);
  const [selectedItemForEdit, setSelectedItemForEdit] = useState(null);
  const [pickupRequestModalVisible, setPickupRequestModalVisible] =
    useState(false);
  const [deliveryRequestModalVisible, setDeliveryRequestModalVisible] =
    useState(false);
  const [selectedRiderDetails, setSelectedRiderDetails] = useState(null);
  const [pickupDeliveryRequestData, setPickupDeliveryRequestData] =
    useState(null);

  const [modalVisible, setModalVisible] = useState(false);
  const [apiResStatus, setApiResStatus] = useState(null);
  const [apiResMessage, setApiResMessage] = useState("");

  const handleItemPress = (item) => {
    setSelectedItem((prevSelectedItem) =>
      prevSelectedItem === item.id ? null : item.id
    );
    setSelectedItemForEdit(item.id);
    // Set the selected rider details when an item is pressed
    setSelectedRiderDetails(item.rider_details);
  };

  const navigate = useNavigate();

  const [collectPaymentResponse, setCollectPaymentResponse] = useState(null);
  const receiveResponse = ({ message, status, modalFun }) => {
    setApiResStatus(status);
    setApiResMessage(message);
    setCollectPaymentResponse(modalFun);
  };
  useEffect(() => {
    if (collectPaymentResponse !== null) {
      callRequestApi();
      setModalVisible(true);
      setCollectPaymentResponse(null);
    }
  }, [collectPaymentResponse]);

  const itemTemplate = (item, index) => {
    let formattedPickupDeliveryDate = "";
    let pickupDeliveryOn = "";
    let customerName = "";
    let customerMobile = "";
    let customerAddress = "";
    let pickupDeliveryTimeSlot = "";
    let riderFirstName = "";
    let riderLastName = "";
    let pickupDeliveryStatus = "";
    let pickupDeliveryOrderStatus = "";
    let pickupDeliveryRequestId = "";
    let storeCustomerId = "";
    let orderId = "";
    let orderNo = "";
    let invoiceNo = "";
    let createdDate = "";
    let remarks = "";
    if (JobType == "pickup") {
      formattedPickupDeliveryDate = formatDate(item?.pickupOn);
      pickupDeliveryOn = item?.pickupOn;
      customerName = item?.customerName;
      customerMobile = item?.customerMobile;
      customerAddress = item?.customerAddress;
      pickupDeliveryTimeSlot = item?.pickupTimeSlot;
      riderFirstName = item?.rider?.firstName;
      riderLastName = item?.rider?.lastName;
      pickupDeliveryStatus = item?.pickupStatus;
      pickupDeliveryOrderStatus = "";
      pickupDeliveryRequestId = item?.id;
      storeCustomerId = item?.storeCustomerId;
      orderId = null;
      orderNo = null;
      invoiceNo = null;
      createdDate = null;
      remarks = item?.remarks;
    } else {
      formattedPickupDeliveryDate = formatDate(item?.deliveryOn);
      pickupDeliveryOn = item?.deliveryOn;
      customerName = item?.order?.customerName;
      customerMobile = item?.order?.customerMobile;
      customerAddress = item?.order?.customerAddress;
      pickupDeliveryTimeSlot = item?.deliveryTimeSlot;
      riderFirstName = item?.rider?.firstName;
      riderLastName = item?.rider?.lastName;
      pickupDeliveryStatus = item?.deliveryStatus;
      pickupDeliveryOrderStatus = item?.order?.status;
      pickupDeliveryRequestId = item?.id;
      storeCustomerId = item?.order?.storeCustomerId;
      orderId = item?.order?.id;
      orderNo = item?.order?.orderNo;
      invoiceNo = item?.order?.invoiceNo;
      createdDate = formatDate(item?.createdDate);
      remarks = null;
    }
    return (
      <Accordion>
        <AccordionTab
          key={index}
          style={{
            "--backgroundColor-AccordionTab": "#6EA4F5",
          }}
          header={`${index + 1 || "N/A"} | ${formattedPickupDeliveryDate}`}
        >
          <div>
            <div className="flex-row">
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">
                  Customer Details :
                </p>
                <p className="text-lg font-bold capitalize">{customerName}</p>
                <p className="text-lg font-bold capitalize">{customerMobile}</p>
                <p className="text-lg font-bold capitalize">
                  {customerAddress}
                </p>
              </div>
            </div>

            <div className="flex-row">
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">
                  Pickup Time Slot :
                </p>
                <p className="text-lg font-bold capitalize">
                  {pickupDeliveryTimeSlot}
                </p>
              </div>
              {JobType === "delivery" && (
                <div className="col-6">
                  <p className="text-base font-semiBold capitalize">
                    Invoice No. :
                  </p>
                  <p className="text-lg font-bold capitalize">
                    {invoiceNo + " - " + createdDate}
                  </p>
                </div>
              )}
            </div>

            <div className="flex-row">
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">
                  Rider Details :
                </p>
                <p className="text-lg font-bold capitalize">
                  {riderFirstName} {riderLastName}
                </p>
              </div>

              <div className="col-6">
                <p className="text-base font-semiBold capitalize">Status :</p>
                <p className="text-lg font-bold capitalize">
                  {pickupDeliveryStatus.replace(/_/g, " ")}
                </p>
              </div>
            </div>
            <div className="flex-row">
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">
                  Store Details :
                </p>
                <p className="text-lg font-bold capitalize">
                  {item.store.storeName}
                </p>
              </div>
              <div className="col-6">
                <p className="text-base font-semiBold capitalize">
                  Remark :
                </p>
                <p className="text-lg font-bold capitalize">
                  {item.remarks}
                </p>
              </div>
              
            </div>
          </div>
        </AccordionTab>
      </Accordion>
    );
  };

  const listTemplate = (items) => {
    if (!items || items.length === 0) return null;

    let list = items.map((product, index) => {
      return itemTemplate(product, index);
    });

    return <div>{list}</div>;
  };

  return (
    <div className="mx-4 my-2">
      <DataView
        value={orderInfoData}
        listTemplate={listTemplate}
        paginator
        rows={20}
      />
    </div>
  );
};

export default AdminJobRequests;
